var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import ReactPaginate from 'react-paginate';
import PropTypes from 'prop-types';
export default class Pagination extends PureComponent {
    render() {
        const _a = this.props, { pagesOutsideElipses, pagesBetweenElipses } = _a, rest = __rest(_a, ["pagesOutsideElipses", "pagesBetweenElipses"]);
        return (React.createElement(ReactPaginate, Object.assign({ marginPagesDisplayed: pagesOutsideElipses, pageRangeDisplayed: pagesBetweenElipses, previousLabel: '<', nextLabel: '>', breakLabel: "...", containerClassName: "pagination", pageClassName: "pageNumber", activeClassName: "active pageNumber", previousClassName: "arrow", nextClassName: "arrow", breakClassName: "ellipses" }, rest)));
    }
}
Pagination.propTypes = {
    initialPage: PropTypes.number,
    pagesOutsideElipses: PropTypes.number,
    pagesBetweenElipses: PropTypes.number,
};
Pagination.defaultProps = {
    initialPage: 0,
    pagesOutsideElipses: 1,
    pagesBetweenElipses: 3,
};
